import { z } from 'zod'
import { RequestResponse } from '@/common/types_and_interfaces.ts'
import { parseRequestError } from '@/common/utilities.ts'
import axiosInstance from '@/libs/axios_config.ts'

const ProgramEnrollmentWindowStatusResp = z.object({
  renewal_enrollment_open: z.boolean(),
  general_enrollment_open: z.boolean(),
})
type ProgramEnrollmentWindowStatusResp = z.infer<
  typeof ProgramEnrollmentWindowStatusResp
>
export async function getProgramEnrollmentWindowStatus(): Promise<
  RequestResponse<ProgramEnrollmentWindowStatusResp>
> {
  try {
    const response = await axiosInstance.get(
      '/public/program/enrollment_window'
    )
    return {
      data: ProgramEnrollmentWindowStatusResp.parse(response.data),
      error: null,
    }
  } catch (e) {
    return { data: null, error: parseRequestError(e) }
  }
}
